const getFirstActiveTeam = currentUser => {
    return currentUser?.ownedTeams?.find(t => t.hasActiveSubscription) || null;
};

// isIconCreator & isPhotoCreator handle dashboard and overall menu show
// allowedToUploadIcons & allowedToUploadPhotos handle submit links
export const creatorToolsCheck = ({ isIconCreator, isPhotoCreator }) => {
    // NOTE: isCreator on currentUser object is deprecated - please use `isIconCreator || isPhotoCreator`
    const isCreator = isIconCreator || isPhotoCreator;

    return {
        showMenu: isCreator,
        showIconDashboard: isIconCreator,
        showPhotoDashboard: isPhotoCreator,
        showSubmitIcons: isIconCreator,
        showSubmitPhotos: isPhotoCreator
    };
};

export const getAuthMenuVisibility = (currentUser = {}) => {
    const firstActiveTeam = getFirstActiveTeam(currentUser);
    const creatorTools = creatorToolsCheck(currentUser);
    return {
        firstActiveTeam,
        creatorTools
    };
};

export default getAuthMenuVisibility;
